export default "__VITE_ASSET__GmrpWpz0__"